























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import CarForm from '@/components/Car/CarForm.vue';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { GQL_updateCar } from '@/queries/__generated__/updateCar';
import gql from 'graphql-tag';
import { GET_CAR } from './getCar';

const UPDATE_CAR = gql`
  mutation updateCar(
    $id: ID!,
    $name: String,
    $norwegianListPriceAsNew: Decimal,
    $registrationNumber: String,
  ) {
    updateCar(
      input: {
        car: {
          id: $id,
          name: $name,
          norwegianListPriceAsNew: $norwegianListPriceAsNew,
          registrationNumber: $registrationNumber
        }
      }
    ) {
      car {
        id
        name
        norwegianListPriceAsNew
        registrationNumber
      }
    }
  },
`;

@Component({
  components: {
    CarForm,
  },
})
export default class CarEdit extends Vue {
  @Prop([ Number, String ]) public id!: number | string;
  public GET_CAR = GET_CAR;
  public UPDATE_CAR = UPDATE_CAR;

  @Emit()
  public carUpdated(store: InMemoryCache, query: { data: GQL_updateCar }) {
    return query.data.updateCar && query.data.updateCar.car;
  }
}
